import React from 'react';
import { Box } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import { getDateString } from '../../../../../../../../../../utils/dateUtil';

const EffectiveDateCell = ({ value: { effectiveAt, expiresAt } }) => (
  <Box>
    {getDateString(effectiveAt, 'MM/DD/YYYY')}
    {' '}
    -
    {' '}
    {getDateString(expiresAt, 'MM/DD/YYYY')}
  </Box>
);

EffectiveDateCell.propTypes = {
  value: PropTypes.shape({
    effectiveAt: PropTypes.string,
    expiresAt: PropTypes.string
  })
};

export default EffectiveDateCell;
